import React from 'react';
import SectionHeading from './section-heading-component';
import { SplitSectionProps } from '../types';

const SplitSection: React.FC<SplitSectionProps> = (props) => {
  const { classname, heading, description, headingClasses, child } = props;
  return (
    <div className={`flex justify-between ${classname || ''}`}>
      <SectionHeading
        heading={heading}
        subHeading={description}
        classname={headingClasses}
      />
      {child}
    </div>
  );
};

export default SplitSection;
